import React from 'react';

const Gender = (props) => {
    const { code, description, onlyDesc } = props;
    
    return (
    <>
        {onlyDesc 
            ? <span>{description}</span>
            : <abbr title={description}>{code}</abbr>
        }
    </>        
    );

}

export default Gender;

